<template>
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div> -->
                <el-input class="search_input search_inputBox" v-model="params.contract_no" clearable placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" clearable placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.batch_no" clearable placeholder="批次号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.ship_no" clearable placeholder="船名"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.heap_no" clearable placeholder="堆号"></el-input>
                <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.breed_id" clearable placeholder="树种" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" clearable placeholder="根号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.length" clearable placeholder="长度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.thickness" clearable placeholder="直径"></el-input>

                <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore" v-model="params.supplier_id" clearable placeholder="供应商" @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore" v-model="params.warehouse_id" clearable placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库日期"></el-date-picker>
                </div> 
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" clearable placeholder="备注"></el-input>
                <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList()">查询</el-button>  -->
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="search(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="report.wood.in.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" ></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">根数:{{ statistics.count }}件</div>
                <div class="totalNumber">方数：{{ statistics.cube }}m³</div>
            </div>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="report.wood.in.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
        </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                start_time: "",
                end_time: "",
                customerList : [],
                saleManList : [],
                params : {
                    page : 1,
                    per_page : 50,
                    start_time : "",
                    end_time : "",
                    contract_no	: "",
                    bill_lading_no: "",
                    batch_no: "",
                    ship_no	: "",
                    heap_no	: "",
                    breed_id: "",
                    bale_no: "",
                    thickness: "",
                    length: "",
                    warehouse_id: "",
                    remark: ""
                },
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count : 0,
                    cube : 0,
                },
                brandList : [],
                breedList : [],
                gradeList : [],

                list:[],
                tableCol:[
                    {colName:"根号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"直径",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库人",colKey:"stocker_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},

                    // {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // // {colName:"锁定人",colKey:"locker_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"销售单价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"产地",colKey:"place_origin",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"预计入库",colKey:"expected_storage_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"预计到港",colKey:"expected_arrival_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                // change
                isShowMore :false,
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
            }
        },
        created() {
            // this.start_time = this.$getCurrentMonthStartValueOf();
            // this.end_time = new Date();
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.search();
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.wood.in.list","原木采购入库明细",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.$postColumnList("/erp/report.wood.in.list",this.params,response=>{
                    if(response.data.code == 0){
                        let list = response.data.data.list
                        list.forEach((item,index) => {
                            if(list[index].expected_storage_time!=0){
                                list[index].expected_storage_time = this.formatTime(list[index].expected_storage_time+"000")
                            }else{
                                list[index].expected_storage_time = "";
                            }
                            if(list[index].expected_arrival_time!=0){
                                list[index].expected_arrival_time = this.formatTime(list[index].expected_arrival_time+"000")
                            }else{
                                list[index].expected_arrival_time = "";
                            }
                            if(list[index].inbound_time!=0){
                                list[index].inbound_time = this.formatTime(list[index].inbound_time+"000")
                            }else{
                                list[index].inbound_time = "";
                            }
                            // item.expected_storage_time =  window.moment( Number(item.expected_storage_time) * 1000 ).format("YYYY-MM-DD")
                            // item.expected_arrival_time =  window.moment( Number(item.expected_arrival_time) * 1000 ).format("YYYY-MM-DD")
                        })
                        this.list = list;
                        this.total = parseInt(response.data.data.total);
                        this.statistics = response.data.data.statistics;
                        this.last_page = parseInt(response.data.data.last_page);
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.filter = response.data.data.column;
                        this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                            if(item.colKey=="status_str"){
                                if(this.fields.indexOf(",status,")!=-1){
                                    item.isShow=true;
                                }
                            }
                        })
                    }
                })
            },
            search(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                    this.getList();
                }
            },
            // reset(){
            //     this.start_time = "";
            //     this.end_time = "";
            //     this.params = this.resetSearch(this.params)
            // },
            // 获取客户
            getCustomerList(visible){
                if(visible){
                    this.$getCustomerList(this.params.salesman_id).then(res=>{
                        this.customerList = res.data.data;
                    })
                }
            },
            // 获取销售员
            getSalemanList(visible){
                if(visible){
                    this.$getSalemanList(this.params.customer_id).then(res=>{
                        this.saleManList = res.data.data;
                    })
                }
            },
            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },
            // change
            reset(){
                // this.start_time = this.$getCurrentMonthStartValueOf();
                // this.end_time = new Date();
                this.start_time = "";
                this.end_time = "";
                this.params = this.resetSearch(this.params)
                this.search();
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,1).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
